import CourseCatalog from '@/pages/courses/components/CourseCatalog';
import { courses } from '@/mocks/home';
import { fetchCourseList } from '@/services/course';
import { adaptCourses } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Warm%20elegant%20Chinese%20medicine%20study%20scene%20with%20stacked%20ancient%20medical%20books%2C%20a%20ceramic%20mortar%20filled%20with%20dried%20herbs%20and%20soft%20golden%20light%2C%20dark%20vignette%20in%20lower%20area%20for%20text%20overlay%2C%20cinematic%20editorial%20photography%2C%20deep%20warm%20tones&width=1920&height=560&seq=courses-hero&orientation=landscape';

export default function MasterCoursesPage() {
  // 接口失败时降级为 mock 数据；只取名师课程（courseType=1）
  const { data } = useRequest(
    () => fetchCourseList({ pageIndex: 1, pageSize: 999, courseType: 1 }).then((res) => adaptCourses(res.list)),
    { fallback: courses },
  );

  return (
    <CourseCatalog
      heroImage={HERO_IMAGE}
      eyebrow="名师课程"
      title="名师课程"
      description="由国医大师、名老中医亲自授课，体系化拆解中医传承、辨证思路与临床经验，把真正的临床功夫交到你手上。"
      breadcrumb={[{ label: '首页', to: '/' }, { label: '课程中心' }, { label: '名师课程' }]}
      items={data}
    />
  );
}